export function initActivityHeatmap(): void {
  const container = document.querySelector<HTMLElement>(
    "[data-activity-heatmap]",
  );
  if (!container) return;

  // On mobile, scroll to the right (current week) on load
  if (window.innerWidth < 768) {
    container.scrollLeft = container.scrollWidth;
  }

  // Create tooltip element (reused for all squares)
  let tooltip: HTMLDivElement | null = null;

  const showTooltip = (
    square: HTMLElement,
    _event: MouseEvent | TouchEvent,
  ): void => {
    const date = square.dataset.date;
    const count = parseInt(square.dataset.count || "0", 10);

    if (!date) return;

    // Parse date
    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    // Create or reuse tooltip
    if (!tooltip) {
      tooltip = document.createElement("div");
      tooltip.className =
        "fixed z-50 px-2 py-1 text-xs font-medium text-white bg-slate-900 border border-slate-700 rounded shadow-lg pointer-events-none";
      tooltip.id = "heatmap-tooltip";
      document.body.appendChild(tooltip);
    }

    tooltip.textContent = `${count} test${count !== 1 ? "s" : ""} on ${formattedDate}`;

    // Position tooltip
    const rect = square.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    let top = rect.top - tooltipRect.height - 6;
    let left = rect.left + rect.width / 2 - tooltipRect.width / 2;

    // Keep tooltip in viewport
    if (top < 10) {
      top = rect.bottom + 6;
    }
    if (left < 10) {
      left = 10;
    }
    if (left + tooltipRect.width > window.innerWidth - 10) {
      left = window.innerWidth - tooltipRect.width - 10;
    }

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    tooltip.style.opacity = "1";
  };

  const hideTooltip = (): void => {
    if (tooltip) {
      tooltip.style.opacity = "0";
    }
  };

  // Add event listeners to all day squares
  const squares = container.querySelectorAll<HTMLElement>("[data-heatmap-day]");
  squares.forEach((square) => {
    // Mouse events
    square.addEventListener("mouseenter", (e) => showTooltip(square, e));
    square.addEventListener("mouseleave", hideTooltip);

    // Touch events for mobile
    square.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
        showTooltip(square, e);
      },
      { passive: false },
    );
  });

  // Hide tooltip when touching elsewhere
  document.addEventListener("touchstart", (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest("[data-heatmap-day]")) {
      hideTooltip();
    }
  });

  // Cleanup on turbo navigation
  document.addEventListener(
    "turbo:before-cache",
    () => {
      if (tooltip) {
        tooltip.remove();
        tooltip = null;
      }
    },
    { once: true },
  );
}
